<template>
  <section
    :class="[
      ns.b(),
      ns.is('vertical', isVertical),
      ns.is('off-canvas', offCanvas),
    ]"
    :style="style"
    data-test-name="container"
  >
    <slot />
  </section>
</template>
<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { isNumber } from 'lodash-unified'
import { useNamespace } from '@bigin/hooks'

import type { CSSProperties, Component, VNode } from 'vue'

defineOptions({
  name: 'BContainer',
})
const props = defineProps({
  direction: {
    type: String,
  },
  offCanvas: Boolean,
  asideWidth: [String, Number],
  headerHeight: [String, Number],
})
const slots = useSlots()

const ns = useNamespace('container')

const style = computed(() => {
  let styles: Record<string, any> = {}

  if (props.asideWidth) {
    styles = {
      ...styles,
      ...ns.cssVarBlock({
        'aside-width': isNumber(props.asideWidth)
          ? `${props.asideWidth}px`
          : props.asideWidth,
      }),
    }
  }

  if (props.headerHeight) {
    styles = {
      ...styles,
      ...ns.cssVarBlock({
        'header-height': isNumber(props.headerHeight)
          ? `${props.headerHeight}px`
          : props.headerHeight,
      }),
    }
  }

  return styles as CSSProperties
})

const isVertical = computed(() => {
  if (props.direction === 'vertical') {
    return true
  } else if (props.direction === 'horizontal') {
    return false
  }
  if (slots && slots.default) {
    const vNodes: VNode[] = slots.default()
    return vNodes.some((vNode) => {
      const tag = (vNode.type as Component).name
      return tag === 'BHeader' || tag === 'BFooter'
    })
  } else {
    return false
  }
})
</script>
